module.exports = __webpack_public_path__ + "static/media/api-icon.25b20780.svg";